import { render } from "./mrf_transparency_panel.vue?vue&type=template&id=5ab1a04f"
import script from "./mrf_transparency_panel.js?vue&type=script&lang=js&external"
export * from "./mrf_transparency_panel.js?vue&type=script&lang=js&external"

import "./mrf_transparency_panel.vue?vue&type=style&index=0&id=5ab1a04f&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__